import { render, staticRenderFns } from "./ClinicalRule.vue?vue&type=template&id=528d5949&scoped=true"
import script from "./ClinicalRule.vue?vue&type=script&lang=js"
export * from "./ClinicalRule.vue?vue&type=script&lang=js"
import style0 from "./ClinicalRule.vue?vue&type=style&index=0&id=528d5949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d5949",
  null
  
)

export default component.exports